document.addEventListener("DOMContentLoaded", () => {
  const productsContainer = document.getElementById("infinite-products");
  const paginationEl = document.getElementById("infinite-pagination");

  if (!productsContainer || !paginationEl) return;

  let loading = false;

  // Neue / noch nicht sichtbare Karten sanft einblenden
  const revealItems = () => {
    const items = document.querySelectorAll(
      ".infinite-grid-item:not(.infinite-grid-item--visible)"
    );

    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add("infinite-grid-item--visible");
      }, index * 60); // leichter „Stagger“-Effekt
    });
  };

  // Initiale Produkte animieren
  revealItems();

  const loadMoreOnScroll = () => {
    const nextUrl = paginationEl.dataset.next;
    if (!nextUrl || loading) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const triggerPosition = document.body.offsetHeight - 1200; // 1200px vorm Ende

    if (scrollPosition >= triggerPosition) {
      loading = true;

      fetch(nextUrl)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const page = parser.parseFromString(html, "text/html");

          const newProductsContainer = page.querySelector("#infinite-products");
          const newPaginationEl = page.querySelector("#infinite-pagination");

          if (newProductsContainer) {
            productsContainer.insertAdjacentHTML(
              "beforeend",
              newProductsContainer.innerHTML
            );
          }

          if (newPaginationEl && newPaginationEl.dataset.next) {
            paginationEl.dataset.next = newPaginationEl.dataset.next;
          } else {
            window.removeEventListener("scroll", loadMoreOnScroll);
            paginationEl.remove();
          }

          // neu hinzugefügte Karten animieren
          revealItems();

          loading = false;
        })
        .catch(() => {
          loading = false;
        });
    }
  };

  window.addEventListener("scroll", loadMoreOnScroll);
loadMoreOnScroll(); 
});
